import { useEffect, useState } from 'react';
import styles from './ManagementPage.module.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { HeaderType } from '../../components/Header/types/Header';
import { FooterType } from '../../components/Footer/types/Footer';
import ManagerCard from '../../components/ManagerCard/ManagerCard';
import { Helmet } from 'react-helmet';
import { api } from '../../utils/api';
import { transformManagementList } from '../../utils/transformers';
import Loader from '../../components/Loader/Loader';

interface Manager {
  id: number;
  name: string;
  phone: string;
  projects: string[];
  dispatcher_phone: string;
  email: string;
  working_hours: string;
}

export default function ManagementPage() {
  const [managers, setManagers] = useState<Manager[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchManagers = async () => {
      try {
        setIsLoading(true);
        const managersData = await api.management.getAll();
        const transformedManagers = transformManagementList(managersData);
        setManagers(transformedManagers);
      } finally {
        setIsLoading(false);
      }
    };

    fetchManagers();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>Домоуправление | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/management" />

        <meta property="og:title" content="Домоуправление | Восток Строй" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/management" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Домоуправление | Восток Строй" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <Header theme={HeaderType.Light} />
      <div className={styles.wrapper}>
        <h2>Домоуправление</h2>
        <div className={styles.managers_list}>
          {managers.map((manager: Manager) => (
            <ManagerCard key={manager.id} manager={manager} />
          ))}
        </div>
      </div>
      <Footer theme={FooterType.Light} />
    </>
  );
}